module.exports = [
  require('./list/adult_sapphire_dragon')
]
